import { useMemo } from 'react';
import { css } from 'styled-components';
import type { TabLabelProps } from './Tabs.types';
import {
  LabelButtonBase,
} from './TabLabel.styled';

export function TabLabel({
  tabId,
  label,
  style,
  css: cssProp,
  activeCss,
  activeStyle,
  ...buttonProps
}: TabLabelProps) {
  const hasActiveCSS = Boolean(buttonProps.active && activeCss);
  const hasActiveStyle = Boolean(buttonProps.active && activeStyle);

  const tabStyle = useMemo(() => {
    if (hasActiveStyle) {
      return {
        ...style,
        ...activeStyle,
      };
    }
    return style;
  }, [
    activeStyle,
    hasActiveStyle,
    style,
  ]);
  const tabCSS = useMemo(() => {
    if (hasActiveCSS) {
      return (
        cssProp
          ? css`
          ${cssProp}
          ${activeCss}
         `
          : activeCss
      );
    }
    return cssProp;
  }, [
    activeCss,
    cssProp,
    hasActiveCSS,
  ]);
  return (
    <LabelButtonBase
      css={tabCSS}
      style={tabStyle}
      {...buttonProps}
    >
      {label}
    </LabelButtonBase>
  );
}
